import React from "react";
import "./Footer.css";
import { NavLink } from "react-router-dom";

// Importa los logos necesarios aquí
import companyLogo from "../assets/img/logoprimuscapitalblanco.svg"; // Ruta del logo de la empresa
import CamChP from "../assets/img/logoblanco1536x213.png";
import Ccl from "../assets/img/logos02_1_.png";
import Adex from "../assets/img/logos03_1_.png";
import Wca from "../assets/img/logos04_1_.png";
import Registro from "../assets/archivos/Registro_SBS-Primus_Peru.pdf";
import LibroReclamacionesImg from "../assets/img/libroReclamaciones.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <img src={companyLogo} alt="Company Logo" />
        </div>
        <div className="footer-column">
          <ul className="footer-links">
            <li>
              <NavLink to="/nosotros" style={{ color: "white" }}>
                Nosotros
              </NavLink>
            </li>
            <li>
              <NavLink to="/productosYServicios" style={{ color: "white" }}>
                Productos y Servicios
              </NavLink>
            </li>
            <li>
              <NavLink to="/informaciondeinteres" style={{ color: "white" }}>
                Preguntas Frecuentes
              </NavLink>
            </li>
            <li>
              <NavLink to="/informaciondeinteres" style={{ color: "white" }}>
                Canal de Denuncias
              </NavLink>
            </li>
            <li>
              <NavLink to="/contactanos" style={{ color: "white" }}>
                Trabaja con Nosotros
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <ul className="footer-links">
            <li>
              <NavLink to="/politicadeprivacidad" style={{ color: "white" }}>
                Políticas de Privacidad
              </NavLink>
            </li>
            <li>
              <a
                href="https://corp.primuscapitalsf.com/SucursalVirtual"
                style={{ color: "white" }}
              >
                Sucursal Virtual
              </a>
            </li>
            <li>
              <NavLink to="/contactanos" style={{ color: "white" }}>
                Contáctanos
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h5>Primus Capital Perú</h5>
          <p>
            Av.Jorge Basadre 233, Piso 5, San Isidro, Lima
            <br />
            Teléfono: +511 500 0504
          </p>
        </div>
        <div className="footer-column">
          <h5>Primus Capital Chile</h5>
          <p>
            Apoquindo 3000, piso 10, Las Condes, Región Metropolitana
            <br />
            Teléfono: +562 2411 2100
          </p>
        </div>
        <div className="footer-libro-reclamaciones">
        <a href="/libroreclamaciones">
          <img
            src={LibroReclamacionesImg}
            alt="Libro de Reclamaciones"
            className="libro-reclamaciones-img"
          />
        </a>
      </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-member">
          <div className="titleMiembros"><h4>Miembros de:</h4></div>
          <img src={CamChP} alt="Cámara de Comercio Peruano-Chilena" />
          <img src={Ccl} alt="Cámara de Comercio de Lima" />
          <img src={Adex} alt="Adex" />
          <img src={Wca} alt="Wca" />
        </div>
       
      </div>
      <div className="descargaFooter">
        <div className="descargasFooter-text-container">
          <p>
            PRIMUS CAPITAL S.A.C. Se encuentra inscrita el “Registro de Empresas
            de Factoring no comprendidas en el ámbito de la ley general” de la
            SBS. N° 000017261
          </p>
        </div>
        <div className="descargasFooter-button-container">
          <a href={Registro} download="Registro_SBS-Primus_Peru.pdf">
            <button>Descargar</button>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
